import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function LegalPage({ ns }) {
  const { t, i18n } = useTranslation();
  const { lang = "ar" } = useParams();

  useEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
  }, [lang, i18n]);

  const sectionKeys = {
    privacy: ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"],
    cookies: ["s1", "s2", "s3", "s4", "s5"],
    terms: ["s1", "s2", "s3", "s4", "s5", "s6"],
  }[ns];

  return (
    <main data-testid={`legal-page-${ns}`} className="bg-white">
      <section className="border-b border-slate-200 bg-[#F8FAFC] px-4 py-16 sm:px-6 lg:px-10">
        <div className="mx-auto max-w-4xl">
          <p className="font-mono text-xs uppercase tracking-widest text-[#C85A32]">
            Zynqelix S.A.
          </p>
          <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[#0A2540] sm:text-4xl">
            {t(`pages.${ns}.title`)}
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            {t(`pages.${ns}.updated`)}
          </p>
        </div>
      </section>
      <section className="px-4 py-14 sm:px-6 lg:px-10">
        <article className="mx-auto max-w-4xl space-y-8 text-base leading-relaxed text-slate-700">
          <p className="text-lg text-slate-800">{t(`pages.${ns}.intro`)}</p>
          {sectionKeys.map((k) => (
            <section key={k}>
              <h2 className="font-serif text-xl font-semibold text-[#0A2540]">
                {t(`pages.${ns}.${k}_title`)}
              </h2>
              <p className="mt-3">{t(`pages.${ns}.${k}`)}</p>
            </section>
          ))}
        </article>
      </section>
    </main>
  );
}
